<template>
    <div class="my-set-fate-panel">
        <fate-panel
            v-bind:hideSideBar="false" 
            v-bind:parentFrom="'myui'"
            v-bind:fateInfo="mySetFateInfo"
            v-bind:fateData="mySetFateListData"
            v-bind:fateSideData="mySetFateSideListData"
            v-bind:siZhuLiuNianReverse="parseInt(settingConfigData.sizhuGeShi) == 1">
        </fate-panel>
        <div class="my-set-fate-panel-note dsp-flex">
            <div class="my-set-fate-sizhu">四柱</div>
            <div class="my-set-fate-liuyun">流运</div>
        </div>
    </div>
</template>

<script>
import FatePanel from "./FatePanel.vue";
export default {
    name: 'MySetFatePanel',
    components: { FatePanel },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        mySetFateInfo() {
            return this.$store.state.setting.mySetFateInfo;
        },
        mySetFateListData() {
            var mySetFateListData = [].concat(this.$store.state.setting.mySetFateListData);
                mySetFateListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? mySetFateListData : mySetFateListData.reverse();
            return mySetFateListData;
        },
        mySetFateSideListData() {
            var mySetFateSideListData = [].concat(this.$store.state.setting.mySetFateSideListData);
                mySetFateSideListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? mySetFateSideListData : mySetFateSideListData.reverse();
            return mySetFateSideListData;
        }
    },
    methods: {
        
    }
}
</script>